import {
	Directive,
	ElementRef,
	Input,
	HostListener,
	OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { MaskType } from 'src/app/constants/masks';
import { MaskService } from 'src/app/services/mask.service';

@Directive({
    selector: '[mwpMask]',
    standalone: false
})
export class MaskDirective implements OnInit {
	@Input() public mwpMask: string;
	@Input() public mwpMaskForm: FormGroup;
	@Input() public mwpMaskFormControlName: string;

	constructor(
		public el: ElementRef,
		public maskService: MaskService,
	) { }

	ngOnInit(): void {
		this.maskInput();
	}

	@HostListener('input') onInput(): void {
		this.maskInput();
	}


	@HostListener('paste') onPaste(): void {
		this.maskInput();
	}

	@HostListener('copy', ['$event']) blockCopy(e: Event): void {
		if (e instanceof KeyboardEvent)
            e.preventDefault();

		e.preventDefault();
	}

	@HostListener('cut', ['$event']) blockCut(e: Event): void {
		if (e instanceof KeyboardEvent)
            e.preventDefault();

		e.preventDefault();
	}

	private maskInput() {
		switch (this.mwpMask) {
			case MaskType.phone:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.phoneFormat(this.el.nativeElement.value));
				break;
			case MaskType.social:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.socialFormat(this.el.nativeElement.value));
				break;
			case MaskType.last4:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.last4Format(this.el.nativeElement.value));
				break;
			case MaskType.last4WithMask:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.last4FormatWithMask(this.el.nativeElement.value));
				break;
			case MaskType.systemNumber:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.systemNumberFormat(this.el.nativeElement.value));
				break;
			case MaskType.weight:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.weightFormat(this.el.nativeElement.value));
				break;
			case MaskType.zipCode:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.zipCodeFormat(this.el.nativeElement.value));
				break;
			case MaskType.currency:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.currencyFormat(this.el.nativeElement.value));
				break;
			case MaskType.numericValues:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.numericValues(this.el.nativeElement.value));
				break;
			case MaskType.shortDateCCExpire:
			case MaskType.shortDate:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.shortDateFormat(this.el.nativeElement.value));
				break;
			case MaskType.singleAlphaNumeric:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.singleAlphaNumeric(this.el.nativeElement.value));
				break;
			case MaskType.singleNumeric:
				this.mwpMaskForm.get(this.mwpMaskFormControlName).setValue(this.maskService.singleNumeric(this.el.nativeElement.value));
				break;
		}
	}

	@HostListener('paste', ['$event']) blockPaste(e: Event): void {
		if (e instanceof KeyboardEvent)
            e.preventDefault();

		if (this.mwpMask === MaskType.last4) { return; }
		if (this.mwpMask === MaskType.phone) { return; }
		if (this.mwpMask === MaskType.social) { return; }
		if (this.mwpMask === MaskType.systemNumber) { return; }
		if (this.mwpMask === MaskType.weight) { return; }
		if (this.mwpMask === MaskType.zipCode) { return; }
		if (this.mwpMask === MaskType.currency) { return; }
		if (this.mwpMask === MaskType.numericValues) { return; }
		if (this.mwpMask === MaskType.shortDate) { return; }
		if (this.mwpMask === MaskType.singleAlphaNumeric) { return; }
		if (this.mwpMask === MaskType.singleNumeric) { return; }
		
		e.preventDefault();
	}
}
